
function Lock({ size = 24 }) {
	return (
		<svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M19 11H5C3.89543 11 3 11.8954 3 13V21C3 22.1046 3.89543 23 5 23H19C20.1046 23 21 22.1046 21 21V13C21 11.8954 20.1046 11 19 11Z"
				stroke="#828282"
				strokeWidth="2"
				strokeMiterlimit="10"
				strokeLinecap="square"
			/>
			<path
				d="M12 19C13.1046 19 14 18.1046 14 17C14 15.8954 13.1046 15 12 15C10.8954 15 10 15.8954 10 17C10 18.1046 10.8954 19 12 19Z"
				stroke="#828282"
				strokeWidth="2"
				strokeMiterlimit="10"
				strokeLinecap="square"
			/>
			<path
				d="M17 7.00025V6.00025C17.0131 4.68748 16.5042 3.42328 15.5853 2.48564C14.6664 1.548 13.4128 1.0137 12.1 1.00025H12C10.6872 0.987183 9.42303 1.49605 8.48539 2.41493C7.54776 3.33382 7.01346 4.58749 7 5.90025V7.00025"
				stroke="#828282"
				strokeWidth="2"
				strokeMiterlimit="10"
				strokeLinecap="square"
			/>
		</svg>
	);
}

export default Lock;
